import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { AppThunk } from "src/store";

export interface MenuItem {
  link?: string;
  badge?: string;
  items?: MenuItem[];
  className?: string;
  name: string;
  permissionId: string;
  permissionName: string;
}

export interface MenuItems {
  items: MenuItem[];
}

const createMenuItem = (
  name: string,
  link: string,
  badge: string,
  permissionId: string = '',
  permissionName: string = ''
): MenuItem => ({
  name,
  link,
  className: "active",
  badge,
  permissionId,
  permissionName
});

const menuItems: MenuItems[] = [
  {
    items: [
      createMenuItem("Home", "/", "icon_leftmenu_home_visited"),
      createMenuItem("Manage Products", "/uploadProduct", "icon_leftmenu_manageproducts", '6,7,8,9,10,11,12', 'uploadProduct'),
      createMenuItem("Manage Spare Parts", "/spareUpload", "icon_leftmenu_managespareparts", '16,17,18,19,20', 'uploadSparePart'),
      createMenuItem("Manage Users", "/ManageUsers", "icon_leftmenu_manageusers", '1,2,3,4,5', 'getAllUsers'),
      createMenuItem("Mobile App Usage", "/MobileAppUsage", "icon_leftmenu_mobileapp"),
      createMenuItem("Settings", "/setting", "icon_leftmenu_settings", '49,50,51,52,53', 'getAllProcurementMembers'),
    ],
  },
];

interface LanguageState {
  key: string;
  label: string;
}

interface MenuState {
  MenuItems: MenuItems[];
  LanguageOption: LanguageState;
  ResponsiveSideBar: boolean;
}

const initialState: MenuState = {
  MenuItems: [],
  LanguageOption: null,
  ResponsiveSideBar: true,
};

const slice = createSlice({
  name: "sideBar",
  initialState,
  reducers: {
    getmenu(state: MenuState, action: PayloadAction<{ menuItems: MenuItems[] }>) {
      state.MenuItems = action.payload.menuItems;
    }
  },
});

export const getMenu = (): AppThunk => async (dispatch) => {
  dispatch(slice.actions.getmenu({ menuItems }));
};

export const reducer = slice.reducer;
export default slice;
